import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'miq-errors-card',
  template: `
    <div class="errors-container">
      <div class="title error">
        <mat-icon>error</mat-icon>
        <span l10nTranslate>shared.error</span>
      </div>
      <div class="errorinfo">
        <ul>
          <li *ngFor="let error of errors" l10nTranslate>{{ error }}</li>
        </ul>
      </div>
    </div>
  `,
  styleUrls: ['./errors-card.component.scss'],
  standalone: false,
})
export class ErrorsCardComponent implements OnInit {
  @Input() errors: Set<string>;

  ngOnInit() {
    // required by angular-l10n
  }
}
